module.exports = __webpack_public_path__ + "static/media/Group (3).01516b4f.svg";